import { Box, BoxProps, Typography } from '@material-ui/core';
import React, { FC } from 'react';

import Link from './Link';

const Copyright: FC<BoxProps> = props => {
  return (
    <Box {...props}>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}

        <Link color="inherit" href="https://fitquarters.id/">
          {'Fitquarters'}
        </Link>

        {` ${new Date().getFullYear()}.`}
      </Typography>
    </Box>
  );
};

export default Copyright;
